import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IFeV2ChatBoxPropsType } from '../../../Routes/renderer/feV2ChatBox'

interface IConfig extends Omit<IFeV2ChatBoxPropsType, 'type'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentType: 'location',
  description: 'Ask about sales performance',
  sendStoreId: false,
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'timoney_bk':
      case 'ghai_pop':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: true,
          disableInputField: true,
          bubblePrompts: [
            {
              id: 'sales',
              label: 'Sales',
              prompt: 'Show me the sales performance',
              children: [
                {
                  id: 'yesterday',
                  label: 'Yesterday',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'yesterday',
                  },
                  prompt: 'yesterday',
                },
                {
                  id: 'sales_7days',
                  label: '7 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_7days',
                  },
                  prompt: 'over the past 7 days',
                },
                {
                  id: 'sales_30days',
                  label: '30 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_30days',
                  },
                  prompt: 'over the past 30 days',
                },
                {
                  id: 'sales_90days',
                  label: '90 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_90days',
                  },
                  prompt: 'over the past 90 days',
                },
              ],
              agentCode: 'prompt:sales',
            },
            {
              id: 'daypart',
              label: 'Day Part',
              prompt: 'Show me the sales performance by day part',
              children: [
                {
                  id: 'yesterday',
                  label: 'Yesterday',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'yesterday',
                  },
                  prompt: 'yesterday',
                },
                {
                  id: 'daypart_7days',
                  label: '7 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_7days',
                  },
                  prompt: 'over the past 7 days',
                },
                {
                  id: 'daypart_30days',
                  label: '30 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_30days',
                  },
                  prompt: 'over the past 30 days',
                },
                {
                  id: 'daypart_90days',
                  label: '90 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_90days',
                  },
                  prompt: 'over the past 90 days',
                },
              ],
              agentCode: 'prompt:sales-daypart',
            },
            {
              id: 'revenue-center',
              label: 'Revenue Center',
              prompt: 'Show me the sales performance by revenue center',
              children: [
                {
                  id: 'yesterday',
                  label: 'Yesterday',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'yesterday',
                  },
                  prompt: 'yesterday',
                },
                {
                  id: 'revenue-center_7days',
                  label: '7 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_7days',
                  },
                  prompt: 'over the past 7 days',
                },
                {
                  id: 'revenue-center_30days',
                  label: '30 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_30days',
                  },
                  prompt: 'over the past 30 days',
                },
                {
                  id: 'revenue-center_90days',
                  label: '90 Days',
                  params: {
                    type: 'dateRange',
                    periods: ['current', 'previous', 'lastYear'],
                    dateRangeType: 'rolling_90days',
                  },
                  prompt: 'over the past 90 days',
                },
              ],
              agentCode: 'prompt:sales-revenue-center',
            },
          ],
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
